import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Icon } from 'components/ui';
import skuHelpers from 'utils/skuHelpers';

const LovesCount = ({ product }) => {
    useSelector(state => state.loves.shoppingListIds, shallowEqual);
    const lovesCount = skuHelpers.getProductLovesCount(product);

    return (
        <div css={{ display: 'flex' }}>
            <Icon
                name='heart'
                size='11px'
                css={{ top: '1px' }}
            />
            <span
                css={{
                    marginLeft: '.4em',
                    position: 'relative',
                    top: '.09em'
                }}
            >
                {lovesCount}
            </span>
        </div>
    );
};

export default wrapFunctionalComponent(LovesCount, 'LovesCount');
